<div class="pos-panel">    
    <form #f="ngForm" [formGroup]="form" class="soc-form-wrapper-gap-24">
    <div class="pos-new-entity-header">
        <span class="material-icons cyan">room_service</span>
        <span class="soc-panel-h">{{ ( edit ? 'GROUPS.EDIT' : 'GROUPS.NEW') | translate}}</span>
    </div>
    <p-tabView class="soc-tabview" [(activeIndex)]="activeIndex" (onChange)="changeTab($event)">
        <p-tabPanel header="{{'GROUPS.GENERAL' | translate}}">
            <div class="soc-form-wrapper-gap-24">
                <div style="width: 508px; margin-top: 24px;">
                    <div class="soc-input-wrapper">
                        <label for="name" class="soc-input-lbl w-100 text-start">{{'GROUPS.GROUP_NAME' | translate}}</label>
                        <div class=" soc-error-field-wrapper">
                            <span *ngIf="form.controls['name'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                            <input formControlName="name" type="text" class="soc-input-field soc-input-text" [ngClass]="{'soc-error-active': form.controls['name'].invalid && f.submitted}" placeholder="{{'TYPE_HERE' | translate}}">
                        </div>
                    </div>
                </div>
                <div class="pos-actions-wrapper">
                    <span class="soc-panel-h fw-light">
                        {{'GROUPS.SERVING_MENU_CATEGORIES' | translate}}
                    </span>
                    <span *ngIf="group && group.servingAreMenuCategories" class="soc-cyan-color soc-p">{{group.servingAreMenuCategories.length}} {{'SELECTED' | translate}}</span>
                </div>
                <p-table *ngIf="group && group.servingAreMenuCategories" class="soc-borderless-table" dataKey="menuCategoryId" [value]="menuCategories" [(selection)]="group.servingAreMenuCategories" (onRowSelect)="selectRow($event)" (onRowUnselect)="unselectRow($event)" [scrollable]="true" [virtualScroll]="true" scrollHeight="calc(100vh - 587px)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th [style.max-width]="'72px'">
                            </th>
                            <th>{{"GROUPS.MENU_CATEGORIES" | translate}}</th>
                            <th></th>
                            <th>{{"GROUPS.DIVISION" | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-categoryComb let-rowIndex="rowIndex">

                        <ng-container formArrayName="categories">
                            <tr [formGroupName]="rowIndex">
                                <td [style.max-width]="'72px'">
                                    <p-tableCheckbox [value]="categoryComb" [index]="rowIndex"></p-tableCheckbox> 
                                </td>                         
                                <td style="line-height: 48px">{{categoryComb.menuCategory.name}}</td>
                                <td class="secondary-td">
                                    <span *ngIf="getItemControls(rowIndex).controls['menuCategory'].value != undefined">{{"GROUPS.SERVED_FROM" | translate | lowercase }}</span></td>
                                <td>
                                    <div *ngIf="getItemControls(rowIndex).controls['menuCategory'].value != undefined" class="soc-error-field-wrapper w-100">
                                        <span *ngIf="getItemControls(rowIndex).controls['division'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}"  tooltipPosition="top" class="material-icons soc-error-icon" >info</span>
                                        <p-dropdown [autoDisplayFirst]="false" formControlName="division"
                                            class="w-100 soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator"
                                            [ngClass]="{'soc-error-active-dropdown':  getItemControls(rowIndex).controls['division'].invalid && f.submitted }" 
                                            [filter]="true" [options]="divisions" dataKey="id" optionLabel="name" appendTo="body"
                                            placeholder="{{'SELECT.DIVISION' | translate }}"
                                            filterPlaceholder="{{'SEARCH' | translate }}">
                                        </p-dropdown>
                                    </div>
                        
                                </td>
                            </tr>
                        </ng-container>
                    </ng-template>
                </p-table>
            </div>
        </p-tabPanel>
        <p-tabPanel header="{{'GROUPS.CAPACITY' | translate}}">
            <div class="pos-capacity-wrapper">
                <div class="d-flex justify-content-between">
                    <span class="soc-field-lbl">{{'GROUPS.CAPACITY_LAYOUT' | translate}}</span>
                    <div class="soc-wrapper-gap-12">
                        <span>{{this.totalCapacity}} {{'GROUPS.GUESTS' | translate}} / {{this.selectedLayout ? this.selectedLayout.tables?.length : 0}} {{'GROUPS.TABLES' | translate}} </span>
                        <span class="material-icons cyan">table_bar</span>
                    </div>
                </div>
                <div pDroppable="table" (onDrop)="drop($event)" class="soc-table-group-panel hide_mobile">
                    <ng-container *ngFor="let table of this.selectedLayout.tables">
                        <div *ngIf="!table.isRemoved" class="position-fixed d-flex flex-column align-items-center" [style.top]="table.positionY + 'px'" [style.left]="table.positionX + 'px'">
                            <div class="soc-table-name">{{table.name}}</div>
                            <img pDraggable="table" (onDragStart)="dragStart($event,table)" (contextmenu)=" $event.preventDefault(); mouseDown($event, table);"
                                [src]="getTablePicture(table.capacity)" (onDragEnd)="dragEnd($event)" class="table_img">  
                        </div>
                    </ng-container>
                </div>
                <div id="page-0" class="document-page table_div_drop dropZone show_mobile" #dropZone cdkDropList id="drop-list"
                cdkDropListSortingDisabled="true" (cdkDropListDropped)="itemDropped($event)">
                    <ng-container *ngFor="let field of this.selectedLayout.tables" >
                        <div *ngIf="!field.isRemoved" cdkDrag [cdkDragData]="field"
                            (cdkDragDropped)="changePosition($event,field)" class="drop-item" [style.top]="field.positionY + 'px'"
                            [style.left]="field.positionY + 'px'">
                            <img class="table_img" [src]="getTablePicture(field.capacity)">
                            <div *cdkDragPlaceholder class="field-placeholder" style="display: none;"></div>
                        </div>
                    </ng-container>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-column align-items-start" style="gap: 12px; width: 400px;">
                        <span class="soc-panel-h fw-light">{{'GROUPS.TABLES' | translate}}</span>
                        <span class="soc-info-text text-start">{{'GROUPS.TABLES_TEXT' | translate}}</span>
                    </div>
                    <div class="d-flex justify-content-evenly align-items-center">
                        <div class="d-flex justify-content-evenly" style="gap: 36px">
                            <img class="table_img hide_mobile" *ngFor="let table of tablePictures" [src]="getTablePicture(table.capacity)" pDraggable="table"
                                (onDragStart)="dragStart($event,table)">
                            <div class="sidenav-inner show_mobile" cdkDropList cdkDropListConnectedTo="drop-list">
                                <span id="div1" cdkDrag *ngFor="let table of tablePictures" [cdkDragData]="table" (cdkDragMoved)="moved($event)">
                                    <img class="table_img" [src]="getTablePicture(table.capacity)">
                                    <span *cdkDragPlaceholder class="field-placeholder" style="display: none;"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        </p-tabPanel>
    </p-tabView>
    <hr class="soc-panel-line"/>
    <div class="soc-wrapper-gap-12 justify-content-end">
        <button class="soc-secondary-cyan-btn" (click)="navigateToMain()" type="button">{{'CANCEL' | translate}}</button>
        <button class="soc-basic-cyan-btn" (click)="createOrEditGroup()" type="submit">{{ (edit ? 'GROUPS.EDIT' : 'GROUPS.CREATE_GROUP') | translate}}</button>
    </div>
    </form>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
